// interface CommandBar {
//   openHelpHub: ({ articleId }: { articleId: number }) => void;
// }

export const helphubUtil = (articleId: number) => {
  return window?.CommandBar?.openHelpHub({
    articleId: articleId,
  });
};
